module.exports = __webpack_public_path__ + "static/DSC_9363-85f457ac8a7a710749510575e062a8ea.jpg";